var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClosedFloating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3763_136090)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 32,
    fill: "#EEEDF1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 20C29.134 20 26 23.134 26 27C26 30.866 29.134 34 33 34L47 34C50.866 34 54 30.866 54 27C54 23.134 50.866 20 47 20L33 20ZM33 32C35.7614 32 38 29.7614 38 27C38 24.2386 35.7614 22 33 22C30.2386 22 28 24.2386 28 27C28 29.7614 30.2386 32 33 32Z",
    fill: "#CBC8CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0731 43.5H34.2751V52.096H28.0731V43.5ZM32.4411 44.956H29.9071V50.626H32.4411V44.956ZM35.9691 42.282H37.8451V55.246H35.9691V42.282ZM37.4251 47.168H39.7211V48.708H37.4251V47.168ZM48.904 42.282H50.766V49.506H48.904V42.282ZM50.248 45.096H52.488V46.622H50.248V45.096ZM45.18 43.024H47.168C47.168 46.468 45.012 48.806 41.148 49.814L40.42 48.344C43.598 47.546 45.18 45.894 45.18 43.948V43.024ZM41.036 43.024H46.3V44.494H41.036V43.024ZM42.352 50.024H50.766V55.106H42.352V50.024ZM48.932 51.494H44.186V53.636H48.932V51.494Z",
    fill: "#2E2E30"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3763_136090",
    x: 3,
    y: 5,
    width: 74,
    height: 74,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0 0.2 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3763_136090"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3763_136090",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosedFloating);
export default __webpack_public_path__ + "static/media/closed-floating.3faa8792bfda0c77ec70916fccecf49d.svg";
export { ForwardRef as ReactComponent };